module.exports = __webpack_public_path__ + "static/media/bridesmaids.41bd4999.jpg";